<template>
    <div>
        <div class="content_columns flex">
            <div class="column">
                <component
                    :is="`section-double-${item.key}`"
                    v-for="(item, index) in value.right"
                    :id="`content-builder-double-item-${index}`"
                    :key="index"
                    :value="item.value"
                />
            </div>
            <div class="column">
                <component
                    :is="`section-double-${item.key}`"
                    v-for="(item, index) in value.left"
                    :id="`content-builder-double-item-${index}`"
                    :key="index"
                    :value="item.value"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Text from './Text';
import Image from './Image';
import Video from './Video';
import Gallery from './Gallery';

export default {
    components: {
        'section-double-text': Text,
        'section-double-image': Image,
        'section-double-video': Video,
        'section-double-gallery': Gallery
    },

    props: {
        value: {
            type: Object,
            reqired: true,
            default: () => ({})
        }
    }
};
</script>
